import React from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import CommentListContainer from '../../../features/page/post/comment/CommentListContainer'

interface IProps {
    className?: string
}

const CommentListPage: React.FC<IProps> = ({className}) => {
    return (
        <PageLayout title={'Comment'} className={className}>
            <CommentListContainer />
        </PageLayout>
    )
}

export default CommentListPage
